import React from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";

export class ScoreboardWidgetScoreCellProps extends BaseProps {
  isMainScore: Boolean;
  isWinner: Boolean;
  isLive: Boolean;
  score: Number;
  extraScore: Number;
}

export const ScoreboardCell = (props: ScoreboardWidgetScoreCellProps) => {
  const winnerScoreClassName = props.isMainScore ?
    (props.isWinner ? 'scoreboard-cell-main-score-winner' : 'scoreboard-cell-main-score') :
    (props.isWinner ? 'scoreboard-cell-winner' : '');

  const liveScoreClassName = (props.isLive && !props.isMainScore) ? 'scoreboard-cell-live' : '';
  const className = ['scoreboard-cell-container', props.className, winnerScoreClassName, liveScoreClassName].join(' ');

  return (
    <div className={className}>
      <div className={'scoreboard-cell-relative'}>
        {props.score}
        <div
          className={['scoreboard-widget-extra-score', props.isLive ? 'scoreboard-widget-extra-score-live' : ''].join(' ')}>{props.extraScore}</div>
      </div>
    </div>
  )
};